"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertDropdownResponsesWithOldDataSourceValue = exports.assertDropdownResponsesWithDisplayConditions = exports.assertDropdownResponsesWithDataSources = void 0;
function assertDropdownResponsesWithDataSources(handleSubmissionMock, responses) {
    expect(handleSubmissionMock.mock.calls.length).toBe(1);
    expect(responses.length).toBe(4);
    var colorsResponse = responses.find(function (r) { return r.questionId === 1192002; });
    expect(colorsResponse.answer).toBe("Green");
    expect(colorsResponse.associatedId).toBe(1190204);
    expect(colorsResponse.questionId).toBe(1192002);
    expect(colorsResponse.questionRootId).toBe(1192002);
    var workLocationsResponse = responses.find(function (r) { return r.questionId === 1192003; });
    expect(workLocationsResponse.answer).toBe("502 JUNCTION");
    expect(workLocationsResponse.associatedId).toBe(26986);
    expect(workLocationsResponse.associatedRootId).toBeUndefined();
    expect(workLocationsResponse.questionId).toBe(1192003);
    expect(workLocationsResponse.questionRootId).toBe(1192003);
    expect(workLocationsResponse.associatedLocation).toBeUndefined();
    var customResponse = responses.find(function (r) { return r.questionId === 1192004; });
    expect(customResponse.answer).toBe("Option 1");
    expect(customResponse.associatedId).toBe(1192251);
    expect(customResponse.associatedRootId).toBe(1192251);
    expect(customResponse.questionId).toBe(1192004);
    expect(customResponse.questionRootId).toBe(1192004);
    var moreWorkLocationsResponse = responses.find(function (r) { return r.questionId === 1192005; });
    expect(moreWorkLocationsResponse.answer).toBe("ABBOTT IND SUB");
    expect(moreWorkLocationsResponse.associatedId).toBe(26765);
    expect(moreWorkLocationsResponse.associatedRootId).toBeUndefined();
    expect(moreWorkLocationsResponse.questionId).toBe(1192005);
    expect(moreWorkLocationsResponse.questionRootId).toBe(1192301);
    expect(moreWorkLocationsResponse.associatedLocation).toBeUndefined();
}
exports.assertDropdownResponsesWithDataSources = assertDropdownResponsesWithDataSources;
function assertDropdownResponsesWithDisplayConditions(handleSubmissionMock, responses) {
    expect(handleSubmissionMock.mock.calls.length).toBe(1);
    expect(responses.length).toBe(12);
    var colorsResponse = responses.find(function (r) { return r.questionId === 1227151; });
    expect(colorsResponse.answer).toBe("Green");
    expect(colorsResponse.associatedId).toBe(1190204);
    expect(colorsResponse.questionId).toBe(1227151);
    expect(colorsResponse.questionRootId).toBe(1227151);
    var participantResponse = responses.find(function (r) { return r.questionId === 1227152; });
    expect(participantResponse.answer).toBe("Green");
    expect(participantResponse.questionId).toBe(1227152);
    expect(participantResponse.questionRootId).toBe(1227152);
    var multiSelectResponse = responses.find(function (r) { return r.questionId === 1227153; });
    expect(multiSelectResponse.answer).toBe("Green");
    expect(multiSelectResponse.questionId).toBe(1227153);
    expect(multiSelectResponse.questionRootId).toBe(1227153);
    var customMultiSelectResponse = responses.find(function (r) { return r.questionId === 1227457; });
    expect(customMultiSelectResponse.answer).toBe("green");
    expect(customMultiSelectResponse.questionId).toBe(1227457);
    expect(customMultiSelectResponse.questionRootId).toBe(1227457);
    expect(customMultiSelectResponse.associatedId).toBe(1227703);
    expect(customMultiSelectResponse.associatedRootId).toBe(0);
    var radioResponse = responses.find(function (r) { return r.questionId === 1227452; });
    expect(radioResponse.answer).toBe("Green");
    expect(radioResponse.questionId).toBe(1227452);
    expect(radioResponse.questionRootId).toBe(1227452);
    var dropdownResponse = responses.find(function (r) { return r.questionId === 1227155; });
    expect(dropdownResponse.answer).toBe("Green");
    expect(dropdownResponse.questionId).toBe(1227155);
    expect(dropdownResponse.questionRootId).toBe(1227155);
    var textLineResponse = responses.find(function (r) { return r.questionId === 1227453; });
    expect(textLineResponse.answer).toBe("Green");
    expect(textLineResponse.questionId).toBe(1227453);
    expect(textLineResponse.questionRootId).toBe(1227453);
    var textAreaResponse = responses.find(function (r) { return r.questionId === 1227454; });
    expect(textAreaResponse.answer).toBe("Green");
    expect(textAreaResponse.questionId).toBe(1227454);
    expect(textAreaResponse.questionRootId).toBe(1227454);
}
exports.assertDropdownResponsesWithDisplayConditions = assertDropdownResponsesWithDisplayConditions;
function assertDropdownResponsesWithOldDataSourceValue(handleSubmissionMock, responses) {
    expect(handleSubmissionMock.mock.calls.length).toBe(1);
    expect(responses.length).toBe(1);
    var colorsResponse = responses.find(function (r) { return r.questionId === 1192002; });
    expect(colorsResponse.answer).toBe("Cherry");
    expect(colorsResponse.associatedId).toBe(1190000);
    expect(colorsResponse.questionId).toBe(1192002);
    expect(colorsResponse.questionRootId).toBe(1192002);
}
exports.assertDropdownResponsesWithOldDataSourceValue = assertDropdownResponsesWithOldDataSourceValue;
//# sourceMappingURL=dropdownResponses.js.map